/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, {ReactElement, useEffect, useState} from "react";
import Tree, {TreeNode} from "../tree/Tree";
import "./SideBar.scss";
import {useChartOfAccounts} from "../../contexts/chartofaccounts/ChartOfAccountsContext";
import useAppStore from '../../hooks/useAppStore';
import {isEmpty} from '../../utils/exports';
import {useParams} from "react-router-dom";
import {useFoqalAction} from "../../hooks/useFoqal";
import {useProperties} from "../../contexts/properties/PropertiesContext";
import {buildTreeNodes} from "../../routes/main/account/AccountRouteConstants";
import appCSS from "../../routes/main/mainRoute.module.scss";
import {AuthUser} from "../../contexts/auth_types";

export interface SideBarProps {
    renovationsWorkflow: Array<TreeNode>;
    isPayrollAvailableForCurrentUser: boolean;
    user: AuthUser | null;
}

const grabKeys = (node: TreeNode[], ancestorNode: TreeNode, ancesstorChild: TreeNode, currentAccountId: string) => {
    const keys: Array<string> = [];

    if (node.length > 0) {
        for (let j = 0; j < node.length; j++) {
            const child2 = node[j];
            if (child2?.accountId === currentAccountId) {
                keys.push(ancestorNode?.title, ancesstorChild?.title);
            }
            if (child2?.children) {
                const linkFound = child2?.children.map(a => a.accountId).includes(currentAccountId);
                if (linkFound) keys.push(ancestorNode?.title, ancesstorChild?.title, child2.title);
            }
        }
    }
    return keys;
};

const grabActiveSideBarItem = (arr: TreeNode[], currentAccountId: string) => {
    const parentKeys: Array<string> = [];

    for (let index = 0; index < arr.length; index++) {
        const node: any = arr[index];

        if (isEmpty(node?.children)) break;

        const children: TreeNode[] | undefined = node?.children;
        children?.forEach((child) => {
            if (child.accountId === currentAccountId) {
                parentKeys.push(node?.title);
            }
            const node2 = child.children;
            if (node2) {
                parentKeys.push(...grabKeys(node2, node, child, currentAccountId));
            }
        });
    }
    return parentKeys;
};

export default function SideBar({renovationsWorkflow, isPayrollAvailableForCurrentUser, user}:SideBarProps): ReactElement {
    const appStore = useAppStore();
    const { chartOfAccounts, isReady } = useChartOfAccounts();
    const {currentProperty} = useProperties();
    const sidebarVisible = appStore.isSideBarVisible;

    const params: any = useParams();
    const routeName = params?.id;
    const categoryType = params?.type || appStore.categoryType;

    const [treeNodes, setTreeNodes] = useState<TreeNode[]>([]);

    const {show: showFoqal} = useFoqalAction();

    useEffect(() => {
        if(!isReady || !currentProperty || !chartOfAccounts || (chartOfAccounts && chartOfAccounts.length == 0)){
            return;
        }
        setTreeNodes(buildTreeNodes(currentProperty, chartOfAccounts, isPayrollAvailableForCurrentUser, renovationsWorkflow, user));
    }, [isReady, currentProperty, chartOfAccounts, renovationsWorkflow, isPayrollAvailableForCurrentUser]);

    useEffect(() => {
        appStore.set({ sideBarItem: { parentkeys: grabActiveSideBarItem(treeNodes, routeName) } });
        // appStore.set({ isSideBarVisible: !isEmpty(appStore.sideBarItem?.parentkeys) });
        return () => { };
    }, [treeNodes, params]);

    useEffect(() => {
        const appContentWrapperEl = document.getElementById("viz-app-content-wrapper");

        if (appContentWrapperEl) {
            if (sidebarVisible) {
                appContentWrapperEl.classList.add(appCSS.sidebarVisible);
            } else {
                appContentWrapperEl.classList.remove(appCSS.sidebarVisible);
            }
        }

    }, [sidebarVisible]);

    return (
        <React.Fragment>
            <div
                id="sidebarx"
                className={`sidebar-wrapper ${sidebarVisible ? "sidebar-visible" : ""}`}
                onClick={(e) => {
                    const t = e.target as any;
                    if (t.id === "sidebarx") {
                        appStore.set({ isSideBarVisible: false });
                        showFoqal();
                    }
                }}
            >
                <div className="sidebar">
                    {sidebarVisible && (
                        <div className="sidebar-components-data text-decoration-none text-darkliver pt-5">
                            <Tree
                                type={categoryType}
                                nodes={treeNodes}
                                depth={0}
                                />
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}

